import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { WxLabel } from '../..';
import useMenu from '../../../hooks/api/queries/useMenu';
import { useMenuContext } from '../../../hooks/context/useMenuContext';
import { OutsideCallback } from '../../../hooks/utils/useOutsideCallback';
import { __ } from '../../../i18n/l10n';
import { breakpoint } from '../../../styles/constants';
import { SLUG_CATEGORY } from '../../../styles/slugs';
import { appendCommitHash } from '../../../utils/appendHash';
import { isInCategory } from '../../../utils/constructSlug';
import { FloatingSubMenu } from '../subMenu/FloatingSubMenu';

export const DesktopNavBar = () => {
  const { open, setOpen, selected, setSelected } = useMenuContext();
  const { data } = useMenu();
  let navigate = useNavigate();

  if (!data) return null;

  return (
    <DesktopOnly>
      <MenuUl>
        {/* Logic duplicated and used in src/components/layout/nav/Nav.tsx */}
        {data?.slice(0, 3).map((item, index) => (
          <MenuMain key={`mainMenu-${index}`} id={`mainMenu-${index}-item`}>
            <div
              onClick={
                item.children === undefined
                  ? () =>
                      navigate(
                        appendCommitHash(`/${SLUG_CATEGORY}/${item.slug}`),
                      )
                  : selected === index
                  ? () => setSelected(-1)
                  : () => setSelected(index)
              }
            >
              <WxLabel
                id={selected === index ? 'openSub' : ''}
                label={item.name}
                hover
                active={
                  (open === false && selected === index) ||
                  (selected === -1 &&
                    isInCategory(item, window.location.pathname))
                }
              />
            </div>
            {index === selected && data[index].children && !open && (
              <OutsideCallback
                callback={() => setSelected(-1)}
                authorizedArea="openSub"
              >
                <FloatingSubMenu menuItem={item} />
              </OutsideCallback>
            )}
          </MenuMain>
        ))}
        <MenuMain>
          <WxLabel label={'|'} hover={false} />
        </MenuMain>
        <MenuMain>
          <WxLabel
            label={__('All categories')}
            onClick={() => setOpen(!open)}
            active={open}
            hover
          />
        </MenuMain>
      </MenuUl>
    </DesktopOnly>
  );
};

const MenuUl = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;
  position: relative;

  > *:not(:nth-last-child(2)) {
    cursor: pointer;
  }
`;

const MenuMain = styled.li`
  display: inline-block;
  position: relative;

  > * {
    padding: 00.625rem;
    display: block;

    p {
      font-size: 0.75rem;
    }
  }
`;

export const DesktopOnly = styled.div`
  display: none;
  @media (min-width: ${breakpoint}) {
    display: block;
  }
`;
